import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCachedClientData } from '../utils/clientCache';

function NotFoundWithToken() {
    const navigate = useNavigate();
    const { uid } = useParams(); // Token from URL
    const [clientColors, setClientColors] = useState(null);
    const [clientLogo, setClientLogo] = useState(null);

    useEffect(() => {
        // Load client colors and logo from cache
        if (uid) {
            const cachedClient = getCachedClientData(uid);
            if (cachedClient) {
                if (cachedClient.configuration) {
                    setClientColors({
                        color0: cachedClient.configuration.header_color_0,
                        color1: cachedClient.configuration.header_color_1
                    });
                }
                if (cachedClient.logo_url) {
                    setClientLogo(cachedClient.logo_url);
                }
            }
        }
    }, [uid]);

    const getBackgroundStyle = () => {
        if (clientColors?.color0 && clientColors?.color1) {
            return {
                background: `linear-gradient(150deg, ${clientColors.color0} 20%, ${clientColors.color1} 99%)`
            };
        }
        // Default gradient (light gray)
        return {
            background: 'linear-gradient(150deg, #f8f9fa 0%, #e9ecef 99%)'
        };
    };

    return (
        <div 
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={getBackgroundStyle()}
        >
            <div className="container">
                {/* Client Logo */}
                {clientLogo && (
                    <div className="text-center mb-4">
                        <img 
                            src={clientLogo.startsWith('/') ? clientLogo : `/${clientLogo}`}
                            alt="Logo"
                            style={{ 
                                maxHeight: '60px',
                                maxWidth: '200px',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                )}
                
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6">
                        <div className="card border-0 shadow-sm">
                            <div className="card-body p-5 text-center">
                                <div className="mb-4">
                                    <div 
                                        className="rounded-circle bg-secondary d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '120px', height: '120px' }}
                                    >
                                        <i className="bi bi-exclamation-triangle text-white" style={{ fontSize: '4rem' }}></i>
                                    </div>
                                </div>
                                
                                <h1 className="display-1 fw-bold text-primary">404</h1>
                                <h3 className="mb-3">Página no encontrada</h3>
                                <p className="text-muted mb-4">
                                    Lo sentimos, la página que estás buscando no existe o ha sido movida.
                                </p>

                                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                                    <button 
                                        className="btn btn-primary px-5 py-2 rounded-pill"
                                        onClick={() => navigate('/' + uid)}
                                    >
                                        <i className="bi bi-house me-2"></i>
                                        Ir a Mi Cuenta
                                    </button>
                                    <button 
                                        className="btn btn-outline-secondary px-5 py-2 rounded-pill"
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Volver atrás
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotFoundWithToken;
